import { makeAutoObservable, runInAction } from "mobx";
import { request } from '@src/common';
import navbarStore from "./navbar";
import { HelperCore } from "@/common/dependencies";

class HistorySearchStore {

  data = {
    search: "",
    list: [],
    npt: "",
    loading: false,
  }

  constructor() {
    makeAutoObservable(this)
  }

  setData(n) {
    if(!n) return
    runInAction(() => {
      this.data = {
        ...this.data,
        ...n
      }
    })
  }

  reset() {
    this.setData({
      search: "",
      list: [],
      npt: "",
      loading: false
    })
  }

  getList = HelperCore.debounce((ai_agent=5) => {
    const { search, npt, loading, list } = this.data
    
    if(loading) return
    this.setData({
      loading: true
    })
    const isAISo = navbarStore.sourceId === 1;
    const url = isAISo
      ? "/assistant/combine/conversation/history/search"
      : "/assistant/conversation/history/search";

    const params = { search, npt, page_size: 30, ai_agent };

    if(isAISo){
      params.version = 2;
    }
    request.post(url, params, {
      dataIsJson: true
    })
    .then(res => {
      const { list: _list, npt } = res.data
      this.setData({
        list: [...list, ..._list],
        npt,
        loading: false
      })
    })
  }, 500)
}

const historySearchStore = new HistorySearchStore()

export default historySearchStore